"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.terms", {
		url: "/terms",
		controller: "TermsController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/terms/terms.template.html"
	});
}]);
